import React, { useRef, useEffect } from "react";
import { Theme, makeStyles, useTheme } from "@material-ui/core/styles";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { equipList } from "../constant/equip-options";
am4core.useTheme(am4themes_animated);

const useStyles = makeStyles((theme: Theme) => ({
  root: { height: "100%" },
}));

interface IElectricChart {
  data: Object;
}
const EquipTypeChart = (props: IElectricChart) => {
  const classes = useStyles();
  const theme = useTheme();
  const equipRef = useRef<any>(null);
  const { data } = props;

  useEffect(() => {
    let reData = equipList.map((rs: any) => {
      const dataEvent: any = data;
      const getvalue = dataEvent.equip_type.find(
        (fd: any) => fd._id.equip_type === rs.type
      );

      return { name: rs.id, value: getvalue ? getvalue.count : 0 };
    });

    am4core.createFromConfig(
      {
        paddingRight: theme.spacing(3),
        // paddingLeft: -theme.spacing(13),
        data: reData,
        yAxes: [
          {
            type: "CategoryAxis",
            dataFields: {
              category: "name",
            },

            renderer: {
              // inside: true,
              // grid: {
              //   template: {
              //     strokeOpacity: 0,
              //   },
              // },
              minGridDistance: 15,
              labels: {
                template: {
                  // dx: -theme.spacing(1),
                  // fill: "#ffffff",
                  horizontalCenter: "left",
                  location: 0.5,
                },
              },
              // minWidth: 120,
              // inversed: true,
              grid: {
                template: {
                  location: 0,
                  strokeDasharray: "1,3",
                },
              },
              cellStartLocation: 0.1,
              cellEndLocation: 0.9,
            },
          },
        ],
        xAxes: [
          {
            type: "ValueAxis",

            renderer: {
              opposite: true,
              // inside: true,
              // labels: {
              //   template: {
              //     fillOpacity: 0.3,
              //     dy: 60,
              //   },
              // },
              grid: {
                template: {
                  strokeOpacity: 0,
                },
              },
              baseGrid: {
                strokeOpacity: 0,
              },
            },
            min: 0,
            //cursorTooltipEnabled: false,
          },
        ],
        series: [
          {
            type: "ColumnSeries",
            dataFields: {
              valueX: "value",
              categoryY: "name",
            },
            columns: {
              template: {
                strokeWidth: 0,

                height: am4core.percent(100),
              },
            },
            name: "name",
            sequencedInterpolation: true,
            tooltip: {
              disabled: true,
            },
            bullets: [
              {
                type: "LabelBullet",
                label: {
                  text: "{value}",
                  horizontalCenter: "left",
                  dx: 10,
                  hideOversized: false,
                  truncate: false,
                },
              },
              // {
              //   type: "LabelBullet",
              //   label: {
              //     text: "{name}",
              //     horizontalCenter: "right",
              //     dx: -10,
              //     fill: am4core.color("#fff"),
              //     hideOversized: false,
              //     truncate: false,
              //   },
              // },
            ],
            heatRules: [
              {
                target: "columns.template",
                property: "fill",
                min: "#F5DBCB",
                max: am4core.color(theme.palette.primary.main),
                dataField: "valueX",
              },
            ],
          },
        ],
        columns: {
          template: {
            id: "columnTemplate",
            height: 90,
            maxHeight: 90,
            strokeOpacity: 0,
          },
        },
      },
      equipRef ? equipRef.current : "",

      am4charts.XYChart
    );

    return () => {};
  }, [theme, data]);
  return <div ref={equipRef} className={classes.root}></div>;
};

export default EquipTypeChart;
